module.exports = __webpack_public_path__ + "img/gpay.04861c5.svg";